/* eslint-disable max-len */
import React, { useState, useEffect } from 'react';
import {
  Form,
  Row,
  Spin,
  Col,
  Card,
  Input,
  Button,
  message,
  Modal,
  Empty,
  Typography,
} from 'antd';
import { formatReceivedValues } from 'utils/formatValues';
import { areaBuscar, normalizeData } from 'utils/normalizers';
import Table from 'components/Table';
import { getEstadosGlobales } from 'api/catalogos';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import Select from 'components/Select';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getEmpleado, getEmpleadosFiltered } from 'api/estructuraOrganizacional/empleados';
import { getDatoOperacionalesDeEmpleados } from 'api/estructuraOrganizacional/datosOperacionalesDeEmpleados';
import { getPuestos } from 'api/catalogos/puestos';
import { getUnidadesDeTrabajo } from 'api/estructuraOrganizacional';
import { getPlazasvistaOptimized } from 'api/catalogos/plazas';
import { getAdministracionDePlazasvistaOptimized } from 'api/catalogos/admnistracionDePlazas';
import { getProcesoAsincronoCalculado } from 'api/nominas/procesoAsincronoCalculado/procesoAsincronoCalculado';
import {
  ESTATUS_AUTORIZADO,
  TIPO_DE_FUNCION_JUBILADO,
  TIPO_DE_FUNCION_PENSIONADO,
  PROCESO_ASINCRONO_ANTIGUEDAD,
} from 'utils/constants';

// Components
import { getVacacionesEmpleadosDiasDisfrutados } from 'api/nominas/vacaciones/vacacionesEmpleadosDiasDisfrutados';
import { postObtenerReporte } from 'api/reporteador';
import { DownloadOutlined, EyeOutlined } from '@ant-design/icons';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { getJornadasDetalle } from 'api/catalogos/JornadaDetalle';
import { getJornadas } from 'api/catalogos/jornadas';
import moment from 'moment';
import RegistroGuardiasTable from './RegistroGuardiasTable';

const baseURI = 'nominas/vacaciones-empleados-importar-excel';
const { Text } = Typography;
export const registroGuardiasPrincipalPermission = {
  permissionModel: 'registrodiasguardia',
  catalogsModels: [],
  tabsModels: [],
};

// eslint-disable-next-line react/prop-types
const RegistroGuardiasPrincipal = ({ permission }) => {
  const [loading, setLoading] = useState(false);
  const [calculando, setCalculando] = useState(false);
  const [open, setVisible] = useState(false);
  const [estados, setEstados] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [data, setData] = useState([]);
  const [datosOperacionalesEmpleados, setDatosOperacionalesEmpleados] = useState([]);
  const [plazas, setPlazas] = useState([]);
  const [horarios, setHorarios] = useState([]);
  const [asignacionPlazas, setAsignacionPlazas] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [tiposNominasEmpleados, setTiposNominasEmpleados] = useState([]);
  const [vacacionesEmpleadosPeriodos, setVacacionesEmpleadosPeriodos] = useState([]);
  const [fatherData, setFatherData] = useState({});
  const [form] = Form.useForm();
  const [formEncabezado] = Form.useForm();
  const [is_disable_no_empleado, setdisable_no_Empleado] = useState(false);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfBase64, setPdfBase64] = useState('');
  const [loadingPdfModal, setLoadingPdfModal] = useState(false);

  const numero_empleadoWatcher = Form.useWatch('numero_empleado', formEncabezado);

  const formatReceivedClone = (values) => {
    if (Array.isArray(values)) {
      let valueClone = values.map((e) => formatReceivedValues(e));
      valueClone = valueClone.map((e) => ({
        ...e,
        area_emp: e?.id,
        puesto_emp: e?.id,
        tipo_nomina_emp: e?.id,
        fecha_alta_emp: e?.id,
        antiguedad_emp: e?.id,
        dias_habiles_derecho_emp: e?.id,
        dias_habiles_disfrutados_emp: e?.id,
        dias_habiles_pendientes_emp: e?.id,
      }));
      return valueClone;
    }
    return formatReceivedValues(values);
  };

  const fetchData = async () => {
    setLoading(true);
    const _empleados = await getEmpleadosFiltered();
    const _asignacion_plazas = await getAdministracionDePlazasvistaOptimized();
    const _datosOperacionalesEmpleados = await getDatoOperacionalesDeEmpleados();
    const empsConPlaza = _empleados?.filter((emp) => _asignacion_plazas.some((asigPlaza) => {
      if (emp?.id === asigPlaza?.empleado) {
        return true;
      }
      return false;
    }));
    const empsFiltered = empsConPlaza?.filter((emp) => _datosOperacionalesEmpleados.some((datoOp) => {
      if (datoOp?.empleado === emp?.id) {
        if (datoOp?.tipo_de_funcion !== TIPO_DE_FUNCION_JUBILADO && datoOp?.tipo_de_funcion !== TIPO_DE_FUNCION_PENSIONADO) {
          return true;
        }
        return false;
      }
      return false;
    }));
    setData(formatReceivedClone(empsFiltered));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _tipos_nominas_empleados,
        _asignacion_plazas,
        _plazas,
        _datosOperacionalesEmpleados,
        _empleados,
        _procesoAsincronoCalculado,
        _vacacionesEmpleadosPeriodos,
        _jornadas,
      ] = await Promise.all([
        getEstadosDeEmpleados(),
        getTiposDeNominasEmpleados({ estados_globales: ESTATUS_AUTORIZADO }),
        getAdministracionDePlazasvistaOptimized(),
        getPlazasvistaOptimized(),
        getDatoOperacionalesDeEmpleados(),
        getEmpleadosFiltered(),
        getProcesoAsincronoCalculado(PROCESO_ASINCRONO_ANTIGUEDAD),
        getVacacionesEmpleadosDiasDisfrutados(),
        getJornadas(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setTiposNominasEmpleados(_tipos_nominas_empleados);
        setAsignacionPlazas(_asignacion_plazas);
        setPlazas(_plazas);
        setDatosOperacionalesEmpleados(_datosOperacionalesEmpleados);
        setVacacionesEmpleadosPeriodos(_vacacionesEmpleadosPeriodos);
        const empsConPlaza = _empleados?.filter((emp) => _asignacion_plazas.some((asigPlaza) => {
          if (emp?.id === asigPlaza?.empleado) {
            return true;
          }
          return false;
        }));
        const empsFiltered = empsConPlaza?.filter((emp) => _datosOperacionalesEmpleados.some((datoOp) => {
          if (datoOp?.empleado === emp?.id) {
            if (datoOp?.tipo_de_funcion !== TIPO_DE_FUNCION_JUBILADO && datoOp?.tipo_de_funcion !== TIPO_DE_FUNCION_PENSIONADO) {
              return true;
            }
            return false;
          }
          return false;
        }));
        setEmpleados(_empleados);
        if (_procesoAsincronoCalculado?.calculando) {
          setCalculando(true);
        } else {
          setCalculando(false);
        }
        setHorarios(_jornadas);
        setData(formatReceivedClone(empsFiltered));
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancel = () => {
    setSelectedRowKeys([]);
    setCalculando(false);
    setVisible(false);
    form.resetFields();
  };

  const onClickEdit = async () => {
    setLoading(true);
    const [key] = selectedRowKeys;
    await fetchData();
    const match = data?.find((item) => item.id === key);
    const _empleado = match;
    const _datoOpEmpl = datosOperacionalesEmpleados?.find((datoOp) => datoOp?.empleado === _empleado?.id);
    const _vacacionesEmpleadosPeriodosEmpleado = vacacionesEmpleadosPeriodos?.find((vacaciones) => vacaciones.empleado === _empleado?.id);
    const _jornadaLaboral = horarios?.find((jornada) => jornada?.id === _datoOpEmpl?.jornada);
    setTimeout(() => {
      if (_empleado) {
        form.resetFields();
        const adminPlaza = asignacionPlazas?.find((asigPlaza) => asigPlaza?.empleado_id === _empleado?.id);
        const plazaEmp = plazas?.find((plaza) => plaza?.id === adminPlaza?.plaza_id);
        const tipoNominaEmp = tiposNominasEmpleados?.find((tne) => tne?.id === _datoOpEmpl?.tipo_de_nomina_empleado)?.descripcion;
        const fechaIngresoEmp = _datoOpEmpl?.fecha_de_alta;
        const diasConDerecho = _vacacionesEmpleadosPeriodosEmpleado?.dias_con_derecho ?? '0';
        const horarioFormateado = _jornadaLaboral
          ? `De ${_jornadaLaboral.rango_hora_inicial.slice(0, 5)} A ${_jornadaLaboral.rango_hora_final.slice(0, 5)}`
          : '';
        setTimeout(() => {
          form.setFieldsValue({
            empleado: _empleado?.numero_y_nombre_completo,
            puesto: adminPlaza?.puesto_clave_y_descripcion,
            unidad_responsable: plazaEmp?.directorio_area_clave_y_nombre,
            tipo_nomina_empleado: tipoNominaEmp,
            fecha_de_reingreso: _datoOpEmpl?.fecha_de_reingreso,
            fecha_alta: fechaIngresoEmp,
            antiguedad: _datoOpEmpl?.antiguedad_texto,
            dias_habiles_derecho: diasConDerecho,
            dias_habiles_disfrutados: _datoOpEmpl?.dias_habiles_disfrutados,
            dias_habiles_pendientes: _datoOpEmpl?.dias_habiles_pendientes,
            estados_globales: _empleado?.estado_del_empleado,
            aplica_guardia: _datoOpEmpl?.aplica_guardia,
          });
          setFatherData({
            id: _empleado?.id,
            antiguedad_numerico_anos: _datoOpEmpl?.antiguedad_numerico_anos,
            antiguedad_numerico_dias: _datoOpEmpl?.antiguedad_numerico_dias,
            antiguedad_texto: _datoOpEmpl?.antiguedad_texto,
            aplica_guardia: _datoOpEmpl?.aplica_guardia,
            jornada_laboral: horarioFormateado,
            de_las: _jornadaLaboral?.rango_hora_inicial ? moment(_jornadaLaboral.rango_hora_inicial, 'HH:mm:ss')
              : moment(moment().format('HH:mm:ss'), 'HH:mm:ss'),
            a_las: _jornadaLaboral?.rango_hora_final ? moment(_jornadaLaboral.rango_hora_final, 'HH:mm:ss')
              : moment(moment().format('HH:mm:ss'), 'HH:mm:ss'),
          });
          setVisible(true);
        });
      }
    });
    setLoading(false);
    formEncabezado.resetFields();
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    form.setFieldsValue(record);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const columns = [
    {
      titleText: 'No. y Nombre de Empleado',
      dataIndex: 'id',
      key: 'id',
      width: 300,
      render: (id, record) => record?.numero_y_nombre_completo,
    },
    {
      titleText: 'Puesto',
      dataIndex: 'puesto_emp',
      key: 'puesto_emp',
      width: 200,
      render: (idEmp) => {
        const asigPlaza = asignacionPlazas?.find((asigPl) => asigPl?.empleado_id === idEmp);
        return asigPlaza?.puesto_clave_y_descripcion;
      },
    },
    {
      titleText: 'Área',
      dataIndex: 'area_emp',
      key: 'area_emp',
      width: 300,
      render: (idEmp) => {
        const asigPlaza = asignacionPlazas?.find((asigPl) => asigPl?.empleado_id === idEmp);
        const plaza = plazas?.find((pl) => pl?.id === asigPlaza?.plaza_id);
        return plaza?.directorio_area_clave_y_nombre;
      },
    },
    {
      titleText: 'Tipo de Nómina Empleado',
      dataIndex: 'tipo_nomina_emp',
      key: 'tipo_nomina_emp',
      width: 300,
      render: (idEmp) => {
        const datoOpEmp = datosOperacionalesEmpleados?.find((datosOp) => datosOp?.empleado === idEmp);
        return tiposNominasEmpleados?.find((tne) => tne?.id === datoOpEmp?.tipo_de_nomina_empleado)?.descripcion;
      },
    },
    {
      titleText: 'Fecha de Alta',
      dataIndex: 'fecha_alta_emp',
      key: 'fecha_alta_emp',
      width: 300,
      render: (idEmp) => {
        const datoOpEmp = datosOperacionalesEmpleados?.find((datoOp) => datoOp?.empleado === idEmp);
        return datoOpEmp?.fecha_de_alta;
      },
    },
    {
      titleText: 'Antigüedad',
      dataIndex: 'antiguedad_emp',
      key: 'antiguedad_emp',
      width: 300,
      render: (idEmp) => {
        const datoOpEmp = datosOperacionalesEmpleados?.find((datosOp) => datosOp?.empleado === idEmp);
        return datoOpEmp?.antiguedad_texto;
      },
    },
    // {
    //   titleText: 'Días Hábiles con Derecho',
    //   dataIndex: 'dias_habiles_derecho_emp',
    //   key: 'dias_habiles_derecho_emp',
    //   width: 300,
    //   render: (idEmp) => {
    //     const _vacacionesEmpleadosPeriodos = vacacionesEmpleadosPeriodos?.find((vacacionesEP) => vacacionesEP?.empleado === idEmp);
    //     return _vacacionesEmpleadosPeriodos?.dias_con_derecho ?? 0;
    //   },
    // },
    // {
    //   titleText: 'Días Hábiles Disfrutados',
    //   dataIndex: 'dias_habiles_disfrutados_emp',
    //   key: 'dias_habiles_disfrutados_emp',
    //   width: 300,
    //   render: (idEmp) => {
    //     const datoOpEmp = datosOperacionalesEmpleados?.find((datosOp) => datosOp?.empleado === idEmp);
    //     return datoOpEmp?.dias_habiles_disfrutados;
    //   },
    // },
    // {
    //   titleText: 'Días Hábiles Pendientes',
    //   dataIndex: 'dias_habiles_pendientes_emp',
    //   key: 'dias_habiles_pendientes_emp',
    //   width: 300,
    //   render: (idEmp) => {
    //     const datoOpEmp = datosOperacionalesEmpleados?.find((datosOp) => datosOp?.empleado === idEmp);
    //     return datoOpEmp?.dias_habiles_pendientes;
    //   },
    // },
    {
      titleText: 'Estatus',
      dataIndex: 'estado_del_empleado',
      key: 'estado_del_empleado',
      width: 200,
      render: (val) => estados?.find((e) => e.id === val)?.descripcion.toUpperCase(),
    },
  ];

  const onClickVerReporte = async () => {
    setLoadingPdfModal(true);
    setShowPdfModal(true);

    const values = {
      ID: 10002,
    };

    try {
      const fileBase64 = await postObtenerReporte(values);

      if (fileBase64) {
        setPdfBase64(fileBase64);
      } else {
        message.error('Error al generar el reporte.');
        setShowPdfModal(false);
      }
    } catch (error) {
      message.error('Error al cargar el reporte.');
      setShowPdfModal(false);
    } finally {
      setLoadingPdfModal(false);
    }
  };

  const onClosePdfModal = () => {
    setShowPdfModal(false);
    setPdfBase64('');
  };
  return (
    <Row className="container">
      <Spin tip="Calculando..." spinning={calculando}>
        <Spin tip="Cargando..." spinning={loading}>
          {!open ? (
            <Form
              layout="vertical"
              form={formEncabezado}
              scrollToFirstError
              name="general"
            >
              <Row gutter={10}>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="numero_empleado"
                    label="No. y Nombre de Empleado"
                    hasFeedback
                  >
                    <Select
                      dataSource={empleados}
                      render={(emp) => emp?.numero_y_nombre_completo}
                      onChange={async (val) => {
                        if (!val) {
                          formEncabezado.setFieldValue('tipo_nomina_empleado', undefined);
                          return;
                        }
                        setLoading(true);
                        const _empleado = empleados?.find((emp) => emp.id === val);
                        // solo para poner el tipo de nomina
                        const _empleadoOp = datosOperacionalesEmpleados?.find((emp) => emp.empleado === _empleado.id);
                        const _nominaEmp = tiposNominasEmpleados?.find((e) => e.id === _empleadoOp?.tipo_de_nomina_empleado);
                        formEncabezado.setFieldValue('tipo_nomina_empleado', _nominaEmp?.id);
                        // aqui termina
                        setData(formatReceivedClone([_empleado]));
                        setLoading(false);
                      }}
                      allowClear
                      disabled={is_disable_no_empleado}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={24} md={8}>
                  <Form.Item
                    name="tipo_nomina_empleado"
                    label="Tipo de Nómina Empleado"
                    hasFeedback
                  >
                    <Select
                      dataSource={tiposNominasEmpleados}
                      onChange={async (tipoNomina) => {
                        if (!tipoNomina) {
                          setdisable_no_Empleado(false);
                          return;
                        }
                        setLoading(true);
                        const datosOpEmp = datosOperacionalesEmpleados?.filter((e) => e.tipo_de_nomina_empleado === tipoNomina);
                        const empleadosFiltrados = empleados?.filter((emp) => datosOpEmp.some((datoOp) => datoOp?.empleado === emp?.id));
                        setData(formatReceivedClone(empleadosFiltrados));
                        setdisable_no_Empleado(true);
                        setLoading(false);
                      }}
                      allowClear
                      disabled={numero_empleadoWatcher}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Table
                data={data}
                cols={columns}
                allowExportExcel={false}
                allowImport={false}
                rowSelection={rowSelection}
                handleOnRowClick={handleOnRowClick}
                controls={{
                  onClickEdit: () => onClickEdit(),
                }}
                // allowCustomImport
                allowReload
                permission={permission}
              />
            </Form>
          ) : (
            <Card
              className="form-container"
              title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Registro de Vacaciones`}
              extra={(
                <FormSubmitControls
                  onCancel={onCancel}
                  loading={loading}
                />
              )}
              bordered={false}
            >
              <Form
                layout="vertical"
                form={form}
                scrollToFirstError
                name="general"
              >
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="empleado"
                      label="No. y Nombre de Empleado"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="puesto"
                      label="Puesto"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="unidad_responsable"
                      label="Área"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={10}>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="tipo_nomina_empleado"
                      label="Tipo de Nómina Empleado"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_alta"
                      label="Fecha de Alta"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="fecha_de_reingreso"
                      label="Fecha de Reingreso"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="antiguedad"
                      label="Antigüedad"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  {/*
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="dias_habiles_derecho"
                      label="Días con Derecho"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="dias_habiles_disfrutados"
                      label="Días Disfrutados"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="dias_habiles_pendientes"
                      label="Días Pendientes"
                      hasFeedback
                    >
                      <Input
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  */}
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="estados_globales"
                      label="Estatus del Empleado"
                      hasFeedback
                    >
                      <Select
                        dataSource={estados}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={24} md={8}>
                    <Form.Item
                      name="aplica_guardia"
                      label="El Empleados Puede Seleccionar Guardias"
                      hasFeedback
                    >
                      <Select
                        trueFalse
                        disabled
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Form.Item hidden>
                  <Button htmlType="submit" />
                </Form.Item>
              </Form>
              <RegistroGuardiasTable
                permission={permission}
                fatherData={fatherData}
              />
            </Card>
          )}

        </Spin>
      </Spin>
    </Row>
  );
};

export default RegistroGuardiasPrincipal;
